import { tscope } from '@i18n/index';
import React from 'react';
import { Flex, Text } from 'ui';

export const ts = tscope('Requisition.documents.generic');

export const OrSeparator = () => (
  <Flex marginTop="110">
    <Text fontWeight="700" fontSize="1.5rem">{ts('or')}</Text>
  </Flex>
);
